import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { PropertyDesc, PropertyGallery, PropertyHeader } from './components';
import { useDocument } from '../../hooks';
import { Loader } from '../../components';
import './Property.scss';

const Property = () => {
  const { id } = useParams();
  const { document, error } = useDocument('properties', id);
  const [unitIndex, setUnitIndex] = useState(0);

  const changeUnit = (i) => {
    setUnitIndex(i);
  };

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!document) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }

  return (
    <div className="property">
      <PropertyHeader {...document} unitIndex={unitIndex} />
      <PropertyGallery {...document} unitIndex={unitIndex} />
      <PropertyDesc
        {...document}
        unitIndex={unitIndex}
        changeUnit={changeUnit}
      />
    </div>
  );
};

export default Property;
